module.exports = __webpack_public_path__ + "img/role_joy.0618f9a9.png";